import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  const tableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "新闻标题",
      prop: "newsTitle",
      minWidth: "280",
      showOverflowTooltip: true
    },
    {
      label: "点击量",
      prop: "clicks",
      minWidth: "120",
      showOverflowTooltip: true,
    },
  ];
  if (args.props.userType == -1 && args.props.deptLevelCode == "001") {
    tableConfig.splice(2, 0, {
      label: "所属分院",
      prop: "deptName",
      width: "200",
      showOverflowTooltip: true
    });
  }
  return (
    <List
      {...args}
      talbeCols={tableConfig}
      onSelectionChange={RCSelectionChange}
    />
  );
};

export default Table;
